import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { HelpCircle } from 'lucide-react';

export default function HelpTooltip({ text, children }) {
  if (!text) return children || null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center justify-center w-4 h-4 rounded-full text-[#94A3B8] hover:text-[#64748B] hover:bg-[#F1F5F9] transition-colors" aria-label="Ayuda">
          <HelpCircle className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" className="text-xs text-[#334155] max-w-xs p-3 leading-relaxed">
        {text}
      </PopoverContent>
    </Popover>
  );
}
